import * as Constants from "../utils/constants";
import axios from "axios";

const token = localStorage.getItem("item");

if (token) {
  Constants.setAuthToken(token);
}

export const createTable = async (
  tableName,
  datasetId,
  selectedColumns,
  selectedRows
) => {
  try {
    const resposne = await axios.post(
      Constants.TABLE,
      {
        name: tableName,
        datasetId: datasetId,
        selectedColumns: selectedColumns,
        selectedRows: selectedRows,
      },
      Constants.CONFIG
    );
    return resposne.data;
  } catch (error) {
    return error.message;
  }
};

export const createPivotTable = async (pivotConfiguration) => {
  try {
    const response = await axios.post(
      Constants.PIVOT,
      pivotConfiguration,
      Constants.CONFIG
    );
    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const getPivotTable = async (pivotID) => {
  try {
    const response = await axios.get(
      `${Constants.PIVOT}/${pivotID}`,
      Constants.CONFIG
    );
    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const getTable = async (tableId) => {
  try {
    const response = await axios.get(
      `${Constants.TABLE}/${tableId}`,
      Constants.CONFIG
    );
    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const deletTheTable = async (tableId) => {
  try {
    const response = await axios.delete(
      `${Constants.TABLE}/${tableId}`,
      Constants.CONFIG
    );
    return response.data;
  } catch (error) {
    return error.message;
  }
};

export const updateTheTable = async (tableId, updateData) => {
  try {
    const response = await axios.put(
      `${Constants.TABLE}/${tableId}`,
      updateData,
      Constants.CONFIG
    );
    return response.data;
  } catch (error) {
    return error.message;
  }
};
